import React, { useCallback, useEffect, useMemo, useState } from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import { Link } from 'react-router-dom';
import TableContainer from 'Common/TableContainer';
import Select from 'react-select';
import { Loader } from '../../../Common/Loader'
// Icons
import { Pencil, Search, Trash2, Plus, } from 'lucide-react';
import Modal from 'Common/Components/Modal';
import DeleteModal from 'Common/DeleteModal';

import {
    getBrands as onGetBrandList,
    deleteBrand as onDeleteBrandList,
} from '../../../helpers/backend_helper';
import { ToastContainer } from 'react-toastify';
import filterDataBySearch from 'Common/filterDataBySearch';
import { Common } from 'helpers/common';
import AddBrand from './AddBrand';
import { getImageUrl } from 'constants/constants';
import ExportExcel from 'pages/Components/ExportExcel';


const BrandList = () => {
    const [brandList, setBrandList] = useState([]);
    const [eventData, setEventData] = useState<any>();
    const [brandData, setBrandData] = useState<any>();
    const [excelData, setExcelData] = useState<any[]>([]);

    const [show, setShow] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);

    const [isLoading, setIsLoading] = useState<boolean>(true);

    const uiHelper = new Common();

    useEffect(() => {
        loadBrands(false);
    }, [])

    async function loadBrands(relead: boolean) {
        try {
            if (brandList.length === 0 || relead) {
                let response = await onGetBrandList();
                if (response.success) {
                    console.log('brands', response.data);
                    setBrandList(response.data as never[]);
                }
                setIsLoading(false)
            }

        } catch (error) {
        } finally {
            setIsLoading(false)
        }
    }
useEffect(() => {
    loadExcelData();
}, [brandList]);

    const loadExcelData = () => {
        if (brandList.length > 0) {

            const filteredList = brandList.map((brand: any) => {
                return {
                    "Brand Name": brand.name,
                    "Brand Description": brand.description,
                    "City": brand.citiesBrands.name,
                    "State": brand.statesBrands.name,
                    "HSN/SAC": brand.hsnsac,
                    "Brand Discount%": brand.discount,
                }
            });
            setExcelData(filteredList);
        }
    }

    // Delete Modal
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const deleteToggle = () => setDeleteModal(!deleteModal);

    // Delete Data
    const onClickDelete = (cell: any) => {
        setDeleteModal(true);
        if (cell.id) {
            setEventData(cell);
        }
    };

    const handleDelete = async () => {
        if (eventData) {
            try {
                await onDeleteBrandList(eventData.id);
                setDeleteModal(false);
                uiHelper.showSuccessMessage('Brand has been deleted successfully.')
                // remove the item and then update list
                setBrandList(brandList => brandList.filter((cat: any, idx) => cat.id !== eventData.id));
            } catch (error: any) {
                setDeleteModal(false);

                if (error?.response?.data?.message.indexOf('foreign key') !== -1) {
                    uiHelper.showErrorMessage("This brand can not be deleted as it has been associated with a product.");
                } else {
                    uiHelper.showErrorMessage("Something went wrong. Please try again later.");
                }
            }

        }
    };
    // 

    // Update Data
    const handleEditDataClick = (ele: any) => {
        setBrandData({ ...ele });
        console.log(ele)

        setIsEdit(true);
        setShow(true);
    };


    const handleAddBrand = () => {
        setBrandData({});
        toggle();
    }

    const onSave = (result: any) => {
        if (isEdit) {
            // setBrandList(prevCat =>
            //     prevCat.map((cat: any, idx) =>
            //         cat.id === brandData.id ? { ...result } as never : { ...cat } as never
            //     )
            // );
            loadBrands(true);
            setIsEdit(false);
        } else {
            loadBrands(true);
            // setBrandList((prevCat) => [{ ...result } as never, ...prevCat],)
        }
        toggle();
    }

    const toggle = useCallback(() => {
        setShow(!show);
        if (show) {
            setBrandData(null);
        }

    }, [show]);

    // Search Data
    const filterSearchData = (e: any) => {
        const search = e.target.value;
        const keysToSearch = ['name', 'description', 'logo', 'isActive'];
        filterDataBySearch(brandList, search, keysToSearch, setBrandList);
    };


    // columns
    const Status = ({ item }: any) => {
        switch (item) {
            case true:
                return (<span className="status px-2.5 py-0.5 inline-block text-xs font-medium rounded border bg-green-100 border-transparent text-green-500 dark:bg-green-500/20 dark:border-transparent">Active</span>);
            case false:
                return (<span className="status px-2.5 py-0.5 inline-block text-xs font-medium rounded border bg-orange-100 border-transparent text-orange-500 dark:bg-orange-500/20 dark:border-transparent">InActive</span>);
        }
    };
    const columns = useMemo(() => [
        {
            header: "Brand Name",
            accessorKey: "name",
            enableColumnFilter: true,
            enableSorting: false,
        },
        {
            header: "Brand Description",
            accessorKey: "description",
            enableColumnFilter: true,
            enableSorting: false,
        },
        ,
        {
            header: "City",
            accessorKey: "citiesBrands.name",
            enableColumnFilter: true,
            enableSorting: false,
        },

        {
            header: "State",
            accessorKey: "statesBrands.name",
            enableColumnFilter: true,
            enableSorting: false,
        },
        {
            header: "HSN/SAC",
            accessorKey: "hsnsac",
            enableColumnFilter: true,
            enableSorting: false,
        },

        {
            header: "Brand Discount%",
            accessorKey: "discount",
            enableColumnFilter: false,
            enableSorting: false,
        },
        {
            header: "Logo",
            accessorKey: "logo",
            enableColumnFilter: false,
            //enableSorting: true,
            cell: (cell: any) => (
                <div >
                    <div className="flex items-center justify-center size-10 font-medium rounded-full shrink-0 bg-slate-200 text-slate-800 dark:text-zink-50 dark:bg-zink-600">
                        {cell.row.original.logo ? <img src={getImageUrl(cell.row.original.logo, 'brandThumbnail')} alt="" className="h-10 rounded-full" /> : (cell.getValue().split(' ').map((word: any) => word.charAt(0)).join(''))}
                    </div>

                </div>
            ),
        },

        {
            header: "Status",
            accessorKey: "isActive",
            enableColumnFilter: false,
            enableSorting: false,
            cell: (cell: any) => (
                <Status item={cell.getValue()} />
            ),
        },
        {
            header: "Action",
            enableColumnFilter: false,
            enableSorting: false,
            cell: (cell: any) => (

                <div className="flex justify-start gap-2" >
                    <Link data-modal-target="addUserModal" to="#!"
                        className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-slate-500 bg-slate-100 hover:text-white hover:bg-slate-500 dark:text-zink-200 dark:bg-zink-600 dark:hover:text-white dark:hover:bg-zink-400"
                        onClick={() => {
                            const data = cell.row.original;
                            handleEditDataClick(data);
                        }}>
                        <Pencil className="inline-block size-4 ltr:mr-1 rtl:ml-1" /> </Link>


                    <Link to="#!"
                        className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-red-500 bg-red-100 hover:text-white hover:bg-red-500 dark:bg-red-500/20 dark:hover:bg-red-500"
                        onClick={() => {
                            const orderData = cell.row.original;
                            onClickDelete(orderData);
                        }}><Trash2 className="inline-block size-4 ltr:mr-1 rtl:ml-1" /> </Link>
                </div>
            ),
        }
    ], []
    );

    const options = [
        { value: 'Select Status', label: 'Select Status' },
        { value: true, label: 'Active' },
        { value: false, label: 'inActive' },
    ];

    const handleChange = (selectedOption: any) => {
        if (selectedOption.value === 'Select Status' || selectedOption.value === 'Hidden') {
            setBrandList(brandList);
        } else {
            const filteredUsers = brandList.filter((data: any) => data.isActive === selectedOption.value);
            setBrandList(filteredUsers);
        }
    };
    const onDownloadExcelError = (errorMessage: string) => {
        uiHelper.showErrorMessage(errorMessage)
    }

    return (
        <React.Fragment>
            {/* <BreadCrumb title='Manage' pageTitle='Categories' /> */}
            <DeleteModal show={deleteModal} onHide={deleteToggle} onDelete={handleDelete} />
            <ToastContainer closeButton={false} limit={1} />
            {/* <div className="card" id="brandListTable">
                <div className="card-body"> */}
            <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12" style={{ marginTop: 15 }}>
                <div className="xl:col-span-12">
                    <div className="card" id="categoriesTable">
                        {/* <div className="card-body"> */}
                        <div className="flex items-center  border-y border-dashed" style={{ padding: 10 }}>
                            <h6 className="text-15 grow">Brands</h6>
                            <div className="shrink-0">
                                <button type="button" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20" onClick={handleAddBrand}><Plus className="inline-block size-4" /> <span className="align-middle">Add Brand</span></button>
                            </div>
                            <div className="shrink-0">
                                <ExportExcel data={excelData} filename="Brands" onDownloadError={onDownloadExcelError}/>
                            </div>
                        </div>

                        {isLoading ? (<Loader />) :
                            (<div >
                                {brandList && brandList?.length > 0 ?
                                    <TableContainer
                                        isPagination={true}
                                        columns={(columns || [])}
                                        data={(brandList || [])}
                                        customPageSize={10}
                                        divclassName="overflow-x-auto"
                                        tableclassName="w-full whitespace-nowrap"
                                        theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
                                        thclassName="px-3.5 py-1.5 font-semibold border-b border-slate-200 dark:border-zink-500"
                                        tdclassName="px-3.5 py-1.0 border-y border-slate-200 dark:border-zink-500"
                                        PaginationClassName="flex flex-col items-center gap-4 px-4 mt-3 md:flex-row"
                                        SearchPlaceholder='Search...'
                                        isGlobalFilter={false}
                                        isSelect={true}
                                    />
                                    :
                                    (<div className="noresult">
                                        <div className="py-6 text-center">
                                            <Search className="size-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
                                            <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                                        </div>
                                    </div>)}
                            </div>)
                        }
                    </div>
                </div>
            </div>
            {/* </div>
            </div> */}


            {/* User Modal  */}
            <Modal show={show} onHide={toggle} id="defaultModal" modal-center="true"
                className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
                dialogClassName="w-screen md:w-[70rem] bg-white shadow rounded-md dark:bg-zink-600">
                {brandData ? <AddBrand onSave={onSave} onHide={toggle} data={brandData} /> : <></>}
            </Modal>
        </React.Fragment>
    );
};

export default BrandList;
